import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import { getDashboardsUserListData } from "../../dashboard/actions/dashboardAction";
import {
  getAllApprovalAnswerKeyListPagination,
  getAllUnApproveRulesListPagination,
  getAllUnApproveInterviewMarksListPagination,
  getAllUnApproveVersionMismatchListPagination,
  getAllApprovalDuplicateRollNoListPagination
} from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getAllUnApproveCutOffListPagination } from "../../interviewProcess/actions/interviewProcessActions";

import _ from "lodash/fp";
import commonLabels from "../../common/labels/common_en.json";

//component to create pagination
const TablePagination = (props) => {
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  //set row per page
  const rowPerPage = props.rowPerPage ? props.rowPerPage : 10;
  //total count
  const totalApplication = props.totalCount ? props.totalCount : 50;

  const searchCode1 =
    props.searchMode && props.textToSearch ? props.textToSearch : false;
  const searchCode2 = props.searchCode2 ? props.searchCode2 : false;
  const searchCode3 = props.searchCode3 ? props.searchCode3 : false;

  props.setListCurrentPage && props.setListCurrentPage(pageNumber - 1);
  useEffect(() => {
    setPageNumber(1);
  }, [props.totalCount, props.searchMode]);

  //to set totalpage required for total  list
  const pagesForTotalApplication = Math.floor(totalApplication / rowPerPage);
  let totalCount = Number.isInteger(totalApplication / rowPerPage)
    ? pagesForTotalApplication
    : pagesForTotalApplication + 1;

  let pageCounter = new Array();
  for (var i = 1; i <= totalCount; i++) {
    pageCounter[i] = i;
  }

  let enablePrev = pageNumber != 1;
  let enableLast = pageNumber != totalCount;

  const nextPageData = () => {
    if (props.onChangeValue) {
      gotoFirstPage();
      props.setonChangeValue(false);
    }

    if (
      pageNumber < totalCount &&
      pageNumber !== totalCount &&
      pageNumber > 0
    ) {
      setPageNumber(parseInt(pageNumber) + 1);
      // eslint-disable-next-line default-case
      switch (props.paginationFor) {
        case "dashboard_user_list":
          return dispatch(getDashboardsUserListData(pageNumber, rowPerPage));
        case "un_answerkey_list":
          return dispatch(
            getAllApprovalAnswerKeyListPagination(pageNumber, rowPerPage)
          );
        case "un_rules_list":
          return dispatch(
            getAllUnApproveRulesListPagination(pageNumber, rowPerPage)
          );
        case "un_cutoff_list":
          return dispatch(
            getAllUnApproveCutOffListPagination(pageNumber, rowPerPage)
          );
        case "un_interviewmarks_list":
          return dispatch(
            getAllUnApproveInterviewMarksListPagination(pageNumber, rowPerPage)
          );
        case "un_verion_mismatch_list":
          return dispatch(
            getAllUnApproveVersionMismatchListPagination(pageNumber, rowPerPage)
          );
        case "un_duplicate_roll_no":
          return dispatch(
            getAllApprovalDuplicateRollNoListPagination(pageNumber, rowPerPage)
          );
            
      }
    }
  };

  const previousPageData = () => {
    if (props.onChangeValue) {
      gotoFirstPage();
      props.setonChangeValue(false);
    }

    if (pageNumber !== 1) {
      setPageNumber(parseInt(pageNumber) - 1);
      // eslint-disable-next-line default-case
      switch (props.paginationFor) {
        case "dashboard_user_list":
          return dispatch(
            getDashboardsUserListData(pageNumber - 1 - 1, rowPerPage)
          );
        case "un_answerkey_list":
          return dispatch(
            getAllApprovalAnswerKeyListPagination(
              pageNumber - 1 - 1,
              rowPerPage
            )
          );
        case "un_rules_list":
          return dispatch(
            getAllUnApproveRulesListPagination(pageNumber - 1 - 1, rowPerPage)
          );
        case "un_cutoff_list":
          return dispatch(
            getAllUnApproveCutOffListPagination(pageNumber - 1 - 1, rowPerPage)
          );
        case "un_interviewmarks_list":
          return dispatch(
            getAllUnApproveInterviewMarksListPagination(
              pageNumber - 1 - 1,
              rowPerPage
            )
          );
        case "un_verion_mismatch_list":
          return dispatch(
            getAllUnApproveVersionMismatchListPagination(
              pageNumber - 1 - 1,
              rowPerPage
            )
          );
          case "un_interviewmarks_list":
            return dispatch(
              getAllUnApproveInterviewMarksListPagination(pageNumber - 1 - 1, rowPerPage)
            ); 
        case "un_duplicate_roll_no":
          return dispatch(
            getAllApprovalDuplicateRollNoListPagination(pageNumber - 1 - 1, rowPerPage)
          );
      }
    }
  };

  const gotoFirstPage = () => {
    setPageNumber(1);
    // eslint-disable-next-line default-case
    switch (props.paginationFor) {
      case "dashboard_user_list":
        return dispatch(getDashboardsUserListData(0, rowPerPage));
      case "un_answerkey_list":
        return dispatch(getAllApprovalAnswerKeyListPagination(0, rowPerPage));
      case "un_rules_list":
        return dispatch(getAllUnApproveRulesListPagination(0, rowPerPage));
      case "un_cutoff_list":
        return dispatch(getAllUnApproveCutOffListPagination(0, rowPerPage));
      case "un_interviewmarks_list":
        return dispatch(
          getAllUnApproveInterviewMarksListPagination(0, rowPerPage)
        );
      case "un_verion_mismatch_list":
        return dispatch(
          getAllUnApproveVersionMismatchListPagination(0, rowPerPage)
        );
            return dispatch(
              getAllUnApproveInterviewMarksListPagination(0, rowPerPage)
            );
      case "un_duplicate_roll_no":
        return dispatch(
          getAllApprovalDuplicateRollNoListPagination(0, rowPerPage)
        );
    }
  };

  const gotoLastPage = () => {
    setPageNumber(totalCount);
    if (pageNumber > 0) {
      // eslint-disable-next-line default-case
      switch (props.paginationFor) {
        case "dashboard_user_list":
          return dispatch(
            getDashboardsUserListData(totalCount - 1, rowPerPage)
          );
        case "un_answerkey_list":
          return dispatch(
            getAllApprovalAnswerKeyListPagination(totalCount - 1, rowPerPage)
          );
        case "un_rules_list":
          return dispatch(
            getAllUnApproveRulesListPagination(totalCount - 1, rowPerPage)
          );
        case "un_cutoff_list":
          return dispatch(
            getAllUnApproveCutOffListPagination(totalCount - 1, rowPerPage)
          );
        case "un_interviewmarks_list":
          return dispatch(
            getAllUnApproveInterviewMarksListPagination(
              totalCount - 1,
              rowPerPage
            )
          );
        case "un_verion_mismatch_list":
          return dispatch(
            getAllUnApproveVersionMismatchListPagination(
              totalCount - 1,
              rowPerPage
            )
          );
        case "un_duplicate_roll_no":
              return dispatch(
                getAllApprovalDuplicateRollNoListPagination(totalCount - 1, rowPerPage)
              );
      }
    }
  };

  const gotoSelectedPage = (pageNo) => {
    setPageNumber(pageNo);

    if (pageNumber > 0) {
      // eslint-disable-next-line default-case
      switch (props.paginationFor) {
        case "dashboard_user_list":
          return dispatch(getDashboardsUserListData(pageNo - 1, rowPerPage));
        case "un_answerkey_list":
          return dispatch(
            getAllApprovalAnswerKeyListPagination(pageNo - 1, rowPerPage)
          );
        case "un_rules_list":
          return dispatch(
            getAllUnApproveRulesListPagination(pageNo - 1, rowPerPage)
          );
        case "un_cutoff_list":
          return dispatch(
            getAllUnApproveCutOffListPagination(pageNo - 1, rowPerPage)
          );
        case "un_interviewmarks_list":
          return dispatch(
            getAllUnApproveInterviewMarksListPagination(pageNo - 1, rowPerPage)
          );
        case "un_verion_mismatch_list":
          return dispatch(
            getAllUnApproveVersionMismatchListPagination(pageNo - 1, rowPerPage)
          );
        case "un_duplicate_roll_no":
              return dispatch(
                getAllApprovalDuplicateRollNoListPagination(totalCount - 1, rowPerPage)
              );
      }
    }
  };

  return (
    <nav aria-label="Page navigation example">
      <ul className="pagination justify-content-left tablePagination">
        <li className="page-item">
          <a className="page-link">
            {commonLabels.GO_TO_PAGE}&nbsp;
            <select
              className="selectPage"
              name="selectedPage"
              value={pageNumber}
              onChange={(event) => gotoSelectedPage(event.target.value)}
            >
              {pageCounter.map((element, index) => {
                return (
                  <option key={index} value={element}>
                    {element}
                  </option>
                );
              })}
            </select>
          </a>
        </li>
        <li
          className={enablePrev ? "page-item" : "page-item disabled"}
          onClick={() => enablePrev && gotoFirstPage()}
        >
          <a className="page-link" tabIndex="-1">
            {"<<"}
          </a>
        </li>
        <li
          className={enablePrev ? "page-item" : "page-item disabled"}
          onClick={() => enablePrev && previousPageData()}
        >
          <a className="page-link">{"<"}</a>
        </li>
        <li
          className={enableLast ? "page-item" : "page-item disabled"}
          onClick={() => enableLast && nextPageData()}
        >
          <a className="page-link">{">"}</a>
        </li>
        <li
          className={enableLast ? "page-item" : "page-item disabled"}
          onClick={() => enableLast && gotoLastPage()}
        >
          <a className="page-link">{">>"}</a>
        </li>
        <li className="page-item">
          <a className="page-link">
            <span>
              {commonLabels.Page}{" "}
              <strong>
                {pageNumber} of {totalCount}
              </strong>{" "}
            </span>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default TablePagination;
